import {MDCSnackbar} from '@material/snackbar';
const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
const buttons = document.querySelectorAll('.mdc-button, .btn');
buttons.forEach(b => {
  b.disabled = false
  b.addEventListener('click', function() {
    const pid = b.dataset.pid
    const ctl = b.dataset.ctl
    if (ctl === "FavoriteStatus") {
      FavoriteStatus(pid)
    }
  })
})

export const FavoriteStatus = (pid) => {
  fetch('/favorite/status/' + pid)
  .then(result => {
    const p = Promise.resolve(result.json());
    p.then(v => {
      snackbar.open()
      snackbar.labelText = v.status_message
      const element = document.querySelector('#fav-' + pid)
      if (element) {
        element.textContent = v.status_icon
      }
    })
  })
}
